<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="代金券列表" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div v-if="!seller.is_platform_store" class="notice">
      <span>套餐过期时间：<span v-if="current_quota" class="red">{{$moment.unix(current_quota.voucherquota_endtime).format('YYYY.MM.DD')}}</span><span class="red" v-else>您还没购买套餐</span></span>
      <div class="common-btn ds-button-small btn" @click="addQuota(current_quota)"><span v-if="current_quota">续期</span><span v-else>购买</span></div>
    </div>
    <div class="pb-30" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
    <div class="div list-wrapper" v-if="voucher_list && voucher_list.length">
    	<div class="voucher_list"  v-for="(item,index) in voucher_list" :key="item.voucher_id" >
    	    <div class="voucher-info">
    	        <div class="price">{{item.vouchertemplate_price}}<span>元</span></div>
    	        <div class="info">
    				<div class="p">订单满{{item.vouchertemplate_limit}}元</div>
    				<div class="p">可领取总数{{item.vouchertemplate_total}}张</div>
    				<div class="p">已领取{{item.vouchertemplate_giveout}}张</div>
    				<div class="p">有效期至{{$moment.unix(item.vouchertemplate_enddate).format('YYYY.MM.DD')}}</div>
    			</div>
    	        <div class="use" @click="goVoucerEdit(item)"><span :style="(item.vouchertemplate_state == 1 && !item.vouchertemplate_giveout) ? 'opacity:1':'opacity:0'">编辑</span></div>
    	    </div>
    	    <div class="voucher-title" >“{{item.vouchertemplate_title}}”</div>
    	</div>
    </div>
    <empty-record v-else-if="voucher_list && !voucher_list.length"></empty-record>
  </div>
  <div class='common-add-btn-wrapper' v-if="current_quota"><div class="div common-btn common-add-btn"  @click="$router.push({name:'SellerVoucherForm',query:{mode:'add'}})">新增</div></div>
  </div>
</template>

<script>
import { getVoucherList, addQuota } from '../../../api/sellerVoucher'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'BalanceHistory',
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      wrapperHeight: 0,

      voucher_list: false,
      current_quota: false,
      voucher_storetimes_limit: false,
      promotion_voucher_price: false,
    }
  },
  created () {

  },

  mounted () {
    this.wrapperHeight = document.documentElement.clientHeight - 90
  },
  computed: {
    ...mapState({
      seller: state => state.seller.info
    })

  },
  methods: {
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getVoucherList(true)
      }
    },
    goVoucerEdit (item) {
      if (item.vouchertemplate_state == 1 && !item.vouchertemplate_giveout) {
        this.$router.push({ name: 'SellerVoucherForm', query: { mode: 'edit', tid: item.vouchertemplate_id } })
      } else {
        Toast('当前代金券不可编辑')
      }
    },
    addQuota (type) {
      MessageBox.prompt('购买单位为月（30天），一次最多购买12个月，每月您需要支付' + this.promotion_voucher_price + '元，相关费用会在店铺的账期结算中扣除，每月最多发布活动' + this.voucher_storetimes_limit + '次', (type ? '续期' : '购买') + '套餐', { inputType: 'number' }).then(({ value, action }) => {
        addQuota(value).then(res => {
          Toast(res.message)
          this.current_quota = { voucherquota_endtime: res.result.voucherquota_endtime }
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },
    getVoucherList () {
      Indicator.open()

          getVoucherList(this.params).then(res => {
            Indicator.close()
            if (res.result.hasmore) {
              this.isMore = true
            } else {
              this.isMore = false
            }
            this.current_quota = res.result.current_quota
            this.promotion_voucher_price = res.result.promotion_voucher_price
            this.voucher_storetimes_limit = res.result.voucher_storetimes_limit
            let temp = res.result.vouchertemplate_list
            if (temp) {
              if (!this.voucher_list) {
                this.voucher_list = temp
              } else {
                this.voucher_list = this.voucher_list.concat(temp)
              }
            }
          }).catch(function (error) {
            Indicator.close()
            Toast(error.message)
          })

    }
  }
}
</script>

<style scoped lang="scss">
    .common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
.container {
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

}
.common-voucher{margin:0.5rem auto}
  .notice{font-size:$subFontSize;padding:.5rem;background:#FCF8E3;color:#C09853;line-height: 1.65rem;
    .red{color:#F00}
    .btn{float:right}
  }
.voucher_list{
      margin: .5rem;
      -webkit-border-radius: .75rem;
      border-radius: .75rem;
      overflow: hidden;
      font-size: .6rem;
      .voucher-info{
              position: relative;
              display: -webkit-box;
              display: -webkit-flex;
              display: flex;
              -webkit-box-align: center;
              -webkit-align-items: center;
              align-items: center;
              -webkit-box-pack: justify;
              -webkit-justify-content: space-between;
              justify-content: space-between;
              padding: .8rem 1rem;
              background: -webkit-linear-gradient(
              45deg
              ,#ff8580,#ea5165);
              background: linear-gradient(
              45deg
              ,#ff8580,#ea5165);
              color: #fff;
              border-bottom: 1px dashed #fff;
              .price{
                  font-size: 1.3rem;
                  font-weight: 700;
                  .span{
                      font-size: .6rem;
                  }
              }
              .use .span{
                  display: -webkit-box;
                  display: -webkit-flex;
                  display: flex;
                  -webkit-box-align: center;
                  -webkit-align-items: center;
                  align-items: center;
                  -webkit-box-pack: center;
                  -webkit-justify-content: center;
                  justify-content: center;
                  padding: .25rem .5rem;
                  background-color: #f9ccd1;
                  font-size: .6rem;
                  color: #ec5667;
                  -webkit-border-radius: .2rem;
                  border-radius: .2rem;
              }
      }
      .voucher-info::before,.voucher-info::after{
          position: absolute;
          content: "";
          bottom: -5px;
          width: 12px;
          height: 12px;
          -webkit-border-radius: 50%;
          border-radius: 50%;
          background-color: #fff;
          z-index: 2;
      }
      .voucher-info::before{
          right: -6px;     
      }
      .voucher-info::after{
          left: -6px;
      }
      .voucher-title{
          display: -webkit-box;
          display: -webkit-flex;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          align-items: center;
          padding: .6rem 1rem;
          background: -webkit-gradient(linear,left top,right top,from(#d6706b),to(#c44654));
          background: -webkit-linear-gradient(left,#d6706b,#c44654);
          background: linear-gradient(
          90deg
          ,#d6706b,#c44654);
          color: #84292b;
      }
  }
</style>
